import CustomDate from './datePicker';
import CustomTime from './timePicker';

const Picker = {
	CustomDate,
	CustomTime,
};

export default Picker;
